<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
      class="add-new-data-sidebar items-no-padding" spacer v-model="sidebarIsActive">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Adicionar nova Permissão</h4>
        <feather-icon icon="XIcon" @click.stop="$emit('isActiveFalse', false)" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

        <div class="p-6" ref="form">
            <vs-input label="Nome" v-model="name" class="mt-5 w-full" name="name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('name')">
                {{ errors.first('name') }}
            </span>
        </div>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="addNewRole">
            Adicionar
            </vs-button>
            <vs-button type="border" color="danger" @click="$emit('isActiveFalse', false)">
            Cancelar
            </vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import role from '../../http/requests/role/index';
    import { mapGetters } from 'vuex';

    export default {
        name: 'create-role-view-sidebar',
        data() {
            return {
                name: ''
            }
        },
        methods: {
            verify(){
                const permissions = localStorage.getItem('permissions');
                const twoFactor = localStorage.getItem('twoFactor')
                if(!permissions && !twoFactor){
                    this.$router.push('/user-settings')
                }else if(!permissions && twoFactor){
                    this.$router.push('/two-factor')
                }
            },
            async addNewRole() {
                if (this.name.trim() !== '') {

                    await role.createRole(this.token, this.name)
                    .then(response => {
                        this.$emit('successfullyCreated', response);

                        return this.$vs.notify({
                            title: 'Sucesso!',
                            text: 'Permissão criada com sucesso!',
                            color: 'success'
                        });
                    })
                    .catch(Exception => {
                        console.log(Exception);
                        return this.$vs.notify({
                            title: 'Erro!',
                            text: 'Algo deu errado!',
                            color: 'danger'
                        });
                    });
                } else {
                    return this.$vs.notify({
                        title: 'Erro!',
                        text: 'Você deve preencher o campo de nome para criar uma nova permissão!',
                        color: 'danger'
                    });
                }
            }
        },
        mounted(){
            this.verify()
        },
        props: {
            sidebarIsActive: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            ...mapGetters([
                'token',
                'users',
                'email'
            ])
        },
        emits: [
            'isActiveFalse',
            'successfullyCreated'
        ]
    }

</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
